// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from './message-list';
import Icon from '@bonprix/pattern-library/templates/icon';
import {Typography} from '@bonprix/design-system';
import {Availability} from '@bonprix/design-system';
import Toggles from "@core/scripts/modules/toggles";

export default function ProductAvailability({texts, product}) {
    const [currentStyle, setCurrentStyle] = useState(product.currentStyle);
    const [currentItem, setCurrentItem] = useState(product.currentItem);
    const [currentItemOption, setCurrentItemOption] = useState(product.currentItemOption);
    const [error, setError] = useState(false);

    const showStockStatement = Toggles.isEnabled('PDP_STOCK_STATEMENT')
    const onlyFewInStock = currentItemOption?.availability?.onlyFewInStock;
    const almostSoldOut = showStockStatement && onlyFewInStock;


    useEffect(() => {
        const subscriptions = [
            MessageBroker.subscribe(ProductMessages.CHANGED, ({style, item, itemOption}) => {
                if (item !== undefined) {
                    setCurrentItem(item);
                }
                if (style !== undefined) {
                    setCurrentStyle(style);
                }
                if (itemOption !== undefined) {
                    setCurrentItemOption(itemOption);
                    setError(false);
                }
            }),
            MessageBroker.subscribe(ProductMessages.ADD_TO_CART_ERROR, ({currentItemOption}) => {
                setError(currentItemOption === null || currentItemOption === undefined);
            }),
            MessageBroker.subscribe(ProductMessages.SELECTION_NEEDED, ({itemOptionNeeded}) => {
                setError(itemOptionNeeded);
            }),
        ];

        return () => subscriptions.forEach((subscription) => MessageBroker.unsubscribe(subscription));
    }, []);

    const availabilitySource = (currentItemOption || currentItem || currentStyle || product).availability;
    const price = (currentItemOption || currentItem).price;

    if (error) {
        return (
            <div className="product__availability-error">
                <Icon name="error" className="product__availability-error-icon" />
                {texts.bff_choose_size}
            </div>
        );
    }

    let availability;
    if (price.unknownPrice) {
        availability = (
            <div className="product__availability-unknown-price">
                <Icon name="error" className="product__availability-unknown-price-icon" />
                {texts['ada_price-not-available']}
            </div>
        );
    } else if (availabilitySource.available) {
        availability = (
            <Availability delivery="available" almostSoldOut={almostSoldOut}>
                <Typography variant="body1" component="span">
                    {availabilitySource.text}
                </Typography>
            </Availability>
        );
    } else if (availabilitySource.tempNotAvailable) {
        availability = (
            <Availability delivery="available-soon" almostSoldOut={almostSoldOut}>
                <Typography variant="body1" component="span">
                    {' '}
                    {availabilitySource.text}
                </Typography>
            </Availability>
        );
    } else if (availabilitySource.soldOut) {
        availability = (
            <Availability delivery="sold-out" almostSoldOut={almostSoldOut}
            >
                <Typography variant="body1" component="span">
                    {' '}
                    {availabilitySource.text}{' '}
                </Typography>
            </Availability>
        );
    }
    return availability;
}
